import { Image } from '@shared/components/image/models';

export const imageMock: Image = {
  link: 'https://cms-test.socooc.com/sites/socooc/files/2025-04/pexels-pixabay-531446.jpg',
  alt: 'Fake image',
  gravity: {
    x: 2496 / 2,
    y: 1481 / 2,
    width: 2496,
    height: 1481,
  },
};
